const MAX_ATTACHMENTS_PER_MESSAGE = 10;
export const MAX_SUPPORA_ATTACHMENT_BYTES = 25 * 1024 * 1024;
const MAX_IMAGE_BYTES = MAX_SUPPORA_ATTACHMENT_BYTES;
const MAX_FILE_BYTES = MAX_SUPPORA_ATTACHMENT_BYTES;
export const DEFAULT_SUPPORA_ATTACHMENT_POLICY = {
    enabled: true,
    allowedKinds: ['image', 'file'],
    maxAttachmentsPerMessage: MAX_ATTACHMENTS_PER_MESSAGE,
    maxImageBytes: MAX_IMAGE_BYTES,
    maxFileBytes: MAX_FILE_BYTES,
};
export function sanitizeAttachmentPolicy(value) {
    if (!isRecord(value)) {
        return null;
    }
    const rawAllowedKinds = value.allowedKinds;
    const allowedKinds = Array.isArray(rawAllowedKinds)
        ? rawAllowedKinds.filter(isAttachmentKind)
        : [];
    if (typeof value.enabled !== 'boolean' ||
        !Array.isArray(rawAllowedKinds) ||
        allowedKinds.length !== rawAllowedKinds.length ||
        new Set(allowedKinds).size !== allowedKinds.length ||
        !isPositiveSafeInteger(value.maxAttachmentsPerMessage) ||
        value.maxAttachmentsPerMessage > MAX_ATTACHMENTS_PER_MESSAGE ||
        !isPositiveSafeInteger(value.maxImageBytes) ||
        value.maxImageBytes > MAX_IMAGE_BYTES ||
        !isPositiveSafeInteger(value.maxFileBytes) ||
        value.maxFileBytes > MAX_FILE_BYTES) {
        return null;
    }
    return {
        enabled: value.enabled,
        allowedKinds,
        maxAttachmentsPerMessage: value.maxAttachmentsPerMessage,
        maxImageBytes: value.maxImageBytes,
        maxFileBytes: value.maxFileBytes,
    };
}
export function isAttachmentDescriptor(value) {
    if (!isRecord(value)) {
        return false;
    }
    return (typeof value.attachmentId === 'string' &&
        value.attachmentId.length > 0 &&
        value.attachmentId.length <= 256 &&
        isAttachmentKind(value.kind) &&
        typeof value.status === 'string' &&
        value.status.length > 0 &&
        value.status.length <= 64 &&
        typeof value.filename === 'string' &&
        value.filename.length > 0 &&
        value.filename.length <= 255 &&
        isNonNegativeSafeInteger(value.sizeBytes) &&
        typeof value.hasOriginal === 'boolean' &&
        typeof value.lifecycleState === 'string' &&
        value.lifecycleState.length > 0 &&
        value.lifecycleState.length <= 64);
}
export function isAttachmentKind(value) {
    return value === 'image' || value === 'file';
}
function isPositiveSafeInteger(value) {
    return isNonNegativeSafeInteger(value) && value > 0;
}
function isNonNegativeSafeInteger(value) {
    return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0;
}
function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
//# sourceMappingURL=attachments.js.map